import React, { useEffect, useState } from "react";
import { wsRequest } from "./wsClient.js";
import Footer from "./Footer.jsx";

// Renders a legal document (Terms & Conditions, Disclaimers, Privacy
// Policy) within the app's own layout — same reasoning and look and
// feel as ContentPage.jsx: SiteHeader above, this centered content
// area, Footer below, same tab, not a bare standalone page.
//
// A legal document can have HTML, an uploaded PDF, or both — if this
// one has no HTML at all but does have a PDF, there's nothing to
// render here, so this redirects straight to the PDF itself (still a
// genuine, backend-served binary file — that part hasn't changed).
export default function LegalDocPage({ docKey }) {
  const [doc, setDoc] = useState(undefined); // undefined = loading, null = not found

  useEffect(() => {
    setDoc(undefined);
    wsRequest("legalDocs.list")
      .then((list) => {
        const found = list.find((d) => d.key === docKey) || null;
        if (found && !found.hasHtml && found.pdfUrl) {
          window.location.replace(found.pdfUrl);
          return;
        }
        setDoc(found);
      })
      .catch(() => setDoc(null));
  }, [docKey]);

  return (
    <div style={{ color: "var(--text-primary)", minHeight: "100vh" }}>
      <div style={{ maxWidth: 700, margin: "0 auto", padding: "0 20px 40px" }}>
        {doc === undefined && <p style={{ opacity: 0.7 }}>Loading…</p>}
        {doc === null && (
          <>
            <h2>Page not found</h2>
            <p style={{ opacity: 0.85 }}>This document doesn't exist, or may have been removed.</p>
          </>
        )}
        {doc && doc.hasHtml && (
          <>
            <h2>{doc.label}</h2>
            {doc.pdfUrl && (
              <p style={{ opacity: 0.85 }}>
                {/* New tab deliberately: this page is the app's own layout
                    (SiteHeader/Footer, client-side routed), while the PDF
                    is a backend-served binary — following it in the same
                    tab drops the visitor out of the app entirely, with
                    only the back button to return. Same target/rel pair
                    already used for the legal links on the signup form.
                    "View", not "Download", because /legal/:key/pdf sends
                    Content-Disposition: inline — the browser shows it in
                    its own PDF viewer rather than saving it. */}
                <a href={doc.pdfUrl} target="_blank" rel="noopener noreferrer" style={{ color: "var(--accent-blue)" }}>
                  View the PDF version
                </a>
              </p>
            )}
            <div style={{ opacity: 0.85, lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: doc.html || "" }} />
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
